/* import __COLOCATED_TEMPLATE__ from './vertical-unpaired-device-icon.hbs.js'; */
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
import { getVerticalColor } from '@dashboard/shared-ui/utils/verticals';

/**
##Svgs::Devices::VerticalUnpairedDeviceIcon

Displays an SVG of the unpaired devices icon with a vertical theme

### Params
@param {String} vertical - The vertical that is using the unpaired device icon. This configures the Square jewel color.
                           Verticals are defined in @dashboard/shared-ui/utils/vertical-configs.

### Example usage
hbs```
  <Svgs::Devices::VerticalUnpairedDeviceIcon @vertical={{Vertical.RESTAURANTS}} />
```
 */
let VerticalUnpairedDeviceIcon = (_dec = readOnly('vertical'), _dec2 = computed('vertical'), _class = class VerticalUnpairedDeviceIcon extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "width", 56);
    _defineProperty(this, "height", 50);
    _defineProperty(this, "viewBox", '0 0 56 50');
    _defineProperty(this, "fill", 'none');
    _initializerDefineProperty(this, 'data-test-svgs-devices-vertical-unpaired-device-icon', _descriptor, this);
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
  get defaultColor() {
    return getVerticalColor(this.vertical);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, 'data-test-svgs-devices-vertical-unpaired-device-icon', [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "defaultColor", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "defaultColor"), _class.prototype), _class);
export { VerticalUnpairedDeviceIcon as default };